import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import { FormCheckbox, FormInput } from 'components/shared/Forms/ReduxForm'
import SortableCell from 'components/shared/Helpers/SortableCell'
import SortableHeaderCell from 'components/shared/Helpers/SortableHeaderCell'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames, sort } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { Field, formValues, reduxForm } from 'redux-form'
import { Button, Form, Icon, Segment, Table } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { users = [] } = state.userAdmin
  return { users }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      push,
    },
    dispatch
  )

class UserBrowser extends React.PureComponent {
  state = {
    sortCol: 'address1',
    direction: 'ascending',
  }

  sortBy(sortCol) {
    const { direction } = this.state

    this.setState({
      sortCol: sortCol,
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  getDealers() {
    // state for sorting
    const { sortCol, direction } = this.state
    const { users, push } = this.props // redux
    const {
      filterActive,
      filterInactive,
      filterArchived,
      adminFilter,
      userFilter,
      dealerFilter,
      bopFilter,
      shopFilter,
      filterText,
    } = this.props // formValues
    let {
      match: {
        params: { user_id },
      },
    } = this.props // withRouter
    user_id = Number(user_id)
    //if (!premiumFilter) filteredUsers = filteredUsers.filter(user => user.kind !== 'Premium')
    //if (!goodFilter) filteredUsers = filteredUsers.filter(user => user.kind !== 'Gut')
    //if (!middleFilter) filteredUsers = filteredUsers.filter(user => user.kind !== 'Mittel')
    //if (!lowFilter) filteredUsers = filteredUsers.filter(user => user.kind !== 'Niedrig')
    let filteredUsers = users.filter((user) => user.user_type !== 'customer')
    if (!filterActive)
      filteredUsers = filteredUsers.filter((user) => user.status !== 'active')
    if (!filterInactive)
      filteredUsers = filteredUsers.filter((user) => user.status !== 'inactive')
    if (!filterArchived)
      filteredUsers = filteredUsers.filter((user) => user.status !== 'archived')
    if (!adminFilter)
      filteredUsers = filteredUsers.filter((user) => user.user_type !== 'admin')
    if (!userFilter)
      filteredUsers = filteredUsers.filter((user) => user.user_type !== 'user')
    if (!dealerFilter)
      filteredUsers = filteredUsers.filter(
        (user) => user.user_type !== 'dealer'
      )
    if (!bopFilter)
      filteredUsers = filteredUsers.filter((user) => user.user_type !== 'bop')
    if (!shopFilter)
      filteredUsers = filteredUsers.filter((user) => user.user_type !== 'shop')
    if (filterText)
      filteredUsers = filteredUsers.filter(
        (user) =>
          (user.email &&
            user.email.toLowerCase().includes(filterText.toLowerCase())) ||
          (user.address1 &&
            user.address1.toLowerCase().includes(filterText.toLowerCase())) ||
          (user.address_number &&
            user.address_number.toString().includes(filterText))
      )
    if (sortCol)
      filteredUsers = filteredUsers.sort((a, b) => sort(a, b, sortCol))
    if (direction !== 'ascending') filteredUsers = filteredUsers.reverse()

    return filteredUsers.map((user, index) => {
      const full_bop =
        user.user_type === 'bop' &&
        !!user.iban &&
        !!user.vat_id &&
        !!user.logo_asset_id
      const needs_validation = full_bop && !user.validated_bop
      const rowStyle = {
        ...(needs_validation && { fontWeight: 'bold' }),
        ...(user.user_type === 'bop' && !full_bop && { color: 'grey' }),
      }
      return (
        <Table.Row
          key={index}
          active={user_id === user.id}
          style={rowStyle}
          onClick={(event) => {
            event.preventDefault()
            push(`${config.nodes.user}${user.id}`)
          }}>
          <SortableCell
            name="status"
            sort={sortCol}
            children={
              <Icon
                {...(user.status === 'inactive' && config.icons.dealerInactive)}
                {...(user.status === 'archived' && config.icons.dealerArchived)}
                {...(user.status === 'deleted' && config.icons.dealerDeleted)}
              />
            }
          />
          <SortableCell
            name="user_type"
            sort={sortCol}
            style={{ color: 'orange', textAlign: 'end' }}
            children={needs_validation && '⬤'}
          />
          <SortableCell
            name="user_type_long"
            sort={sortCol}
            text={
              ['admin', 'user'].includes(user.user_type)
                ? I18n.t('admin.user.type.' + user.user_type)
                : user.kind
            }
          />
          <SortableCell
            name="address_type"
            sort={sortCol}
            children={
              user.address_type &&
              user.address_type.toLowerCase() === 'webanzeige ja' && (
                <Icon name="globe" />
              )
            }
          />
          <SortableCell
            name="address_number"
            sort={sortCol}
            highlight={filterText}
            text={user.address_number && user.address_number.toString()}
          />
          <SortableCell
            name="address1"
            sort={sortCol}
            highlight={filterText}
            text={
              ['admin', 'user'].includes(user.user_type)
                ? user.name
                : user.address1
            }
          />
          <SortableCell
            name="email"
            sort={sortCol}
            highlight={filterText}
            text={user.email}
          />
        </Table.Row>
      )
    })
  }

  render() {
    const { sortCol, direction } = this.state
    const { push } = this.props
    const dark = config.theme.dark

    return (
      <div
        className={classNames([
          'dealerBrowser',
          'form',
          'ui',
          dark && 'inverted',
        ])}>
        <ComponentHeader
          title={I18n.t('admin.user.title.users')}
          customActions={[
            <Field
              component={FormInput}
              icon="search"
              name="filterText"
              placeholder={I18n.t('global.filter')}
            />,
            <Button
              onClick={() => {
                push(`${config.nodes.user}+`)
              }}
              //content={I18n.t('admin.user.button.user')}
              primary
              icon="plus"
            />,
          ]}
        />

        <Segment attached className="filterBar primary">
          <Form.Group>
            <Field
              component={FormCheckbox}
              label={I18n.t('admin.user.title.admin')}
              name="adminFilter"
            />
            <Field
              component={FormCheckbox}
              label={I18n.t('admin.user.title.user')}
              name="userFilter"
            />
            <Field
              component={FormCheckbox}
              label={I18n.t('admin.user.title.dealer')}
              name="dealerFilter"
            />
            <Field
              component={FormCheckbox}
              label={I18n.t('admin.user.title.bop')}
              name="bopFilter"
            />
            <Field
              component={FormCheckbox}
              label={I18n.t('admin.user.title.shop')}
              name="shopFilter"
            />
          </Form.Group>
          <Form.Group>
            <Field
              component={FormCheckbox}
              label={I18n.t('admin.user.title.active')}
              name="filterActive"
            />
            <Field
              component={FormCheckbox}
              label={
                <label>
                  <Icon {...config.icons.dealerInactive} />
                  {I18n.t('admin.user.title.inactive')}
                </label>
              }
              name="filterInactive"
            />
            <Field
              component={FormCheckbox}
              label={
                <label>
                  <Icon {...config.icons.dealerArchived} />
                  {I18n.t('admin.user.title.archived')}{' '}
                </label>
              }
              name="filterArchived"
            />
          </Form.Group>
        </Segment>

        <Segment
          attached
          className={classNames(['payload', 'scroll', dark && 'inverted'])}>
          <Table
            sortable
            compact
            size="small"
            selectable
            singleLine
            basic="very"
            className="spaced">
            <Table.Header>
              <Table.Row>
                <SortableHeaderCell
                  collapsing
                  name="status"
                  title={<Icon name="lock" color="grey" />}
                  onClick={() => this.sortBy('status')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  collapsing
                  name="user_type"
                  title={"⬤"}
                  style={{ color: 'orange', textAlign: 'end' }}
                  onClick={() => this.sortBy('kind')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  name="user_type_long"
                  title={I18n.t('admin.user.title.type')}
                  onClick={() => this.sortBy('type')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  collapsing
                  name="address_type"
                  title={<Icon name="globe" color="grey" />}
                  onClick={() => this.sortBy('address_type')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  name="address_number"
                  title={I18n.t('admin.user.title.customer_number')}
                  onClick={() => this.sortBy('address_number')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  name="address1"
                  title={I18n.t('admin.user.title.dealer_user')}
                  onClick={() => this.sortBy('address1')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  name="email"
                  title={I18n.t('admin.user.title.email')}
                  onClick={() => this.sortBy('email')}
                  sortCol={sortCol}
                  direction={direction}
                />
              </Table.Row>
            </Table.Header>
            <Table.Body children={this.getDealers()} />
          </Table>
        </Segment>
      </div>
    )
  }
}

UserBrowser = UserBrowser = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserBrowser)
UserBrowser = formValues(
  'filterActive',
  'filterInactive',
  'filterArchived',
  'adminFilter',
  'bopFilter',
  'userFilter',
  'dealerFilter',
  'shopFilter',
  'filterText'
)(UserBrowser)
UserBrowser = reduxForm({
  form: 'dealer_list',
  initialValues: {
    filterActive: true,
    filterInactive: false,
    filterArchived: false,
    adminFilter: true,
    bopFilter: false,
    userFilter: false,
    dealerFilter: false,
    shopFilter: false,
    /*
        premiumFilter:  true,
        goodFilter:     true,
        middleFilter:   true,
        lowFilter:      true,
    */
  },
})(UserBrowser)
export default withRouter(UserBrowser)



// WEBPACK FOOTER //
// ./src/components/admin/Users/UserBrowser.jsx